// Add security profile main router component.
// this Route consists of 3 other nested routes
// under "/addACL" defined below
import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, NavLink } from "react-router-dom";
import BasicSettings from "../../../../../Dashboard/Components/SecuritySettings/ACLs/AddACL/BasicSettings";
import Mapping from "../../../../../Dashboard/Components/SecuritySettings/ACLs/AddACL/Mapping";
import Advanced from "../../../../../Dashboard/Components/SecuritySettings/ACLs/AddACL/Advanced";
import DesktopOnlyOverlay from "../../../../../Dashboard/Components/ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import ContentHeader from "../../../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../../Assets/Images/sm-Circle.svg";
import UnsavedChangesAlert from "../../../../../Dashboard/Components/ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";

const AddACL = (props) => {
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [BasicSettingsCreated, setBasicSettingsCreated] = useState(true);
  const [NavIdClicked, setNavId] = useState("");
  // on component mount, we set two global variables for validating the user's unsaved changes and
  // basic settings creation. In case they request leaving the page before saving, we can display
  // the related alert with a decent message for each scenario.
  useEffect(() => {
    window.localStorage.setItem("BasicSettingsCreated", 0); // 1 means true, 0 means false
    window.localStorage.setItem("LastIdClicked", "");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // e stands for the event initiated by the user (in this case: navigating to another tab)
  const validateNavigation = (e, Id) => {
    window.localStorage.setItem("LastIdClicked", Id); // for save and leave or discard and leave buttons
    let UnsavedChangesStatus = parseInt(
      window.localStorage.getItem("HasUnsaveChanges")
    ); //true: 1, false: 0
    let BasicSettingsStatus = parseInt(
      window.localStorage.getItem("BasicSettingsCreated")
    ); //true: 1, false: 0
    if (BasicSettingsStatus === 0) {
      e.preventDefault();
      if (document.getElementById("name") !== null) {
        let ACLName = document.getElementById("name").value;
        if (ACLName.length === 0) {
          document.getElementById("name-label-holder").classList.add("wrong");
        } else {
          setBasicSettingsCreated(false);
        }
      }
    } else {
      if (UnsavedChangesStatus === 0) {
        document.getElementById(Id).click();
        transformIndicator(Id); // gets the id and translates the indicator on the navigator
      } else if (UnsavedChangesStatus === 1) {
        e.preventDefault();
        setUnsavedChanges(true);
        setNavId(Id);
      }
    }
  };
  const transformIndicator = (Id) => {
    if (Id === "mapping") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(134px)";
    } else if (Id === "basic-settings") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else {
      document.getElementById("animated-indicator").style.transform =
        "translateX(269px)";
    }
  };
  const close = () => {
    setUnsavedChanges(false);
  };
  const discard = () => {
    setUnsavedChanges(false);
    window.localStorage.setItem("HasUnsaveChanges", 0);
    document.getElementById(NavIdClicked).click();
  };
  const saveAndLeave = () => {
    setUnsavedChanges(false);
    window.localStorage.setItem("HasUnsaveChanges", 0);
    document.getElementById("save-btn").click();
    setTimeout(() => {
      if (
        window.location.pathname === "/home/acls/addACL/mapping/" ||
        window.location.pathname === "/home/acls/addACL/mapping"
      ) {
        if (
          document.getElementById("bu-error").style.display !== "block" ||
          document.getElementById("reg-error").style.display !== "block" ||
          document.getElementById("country-error").style.display !== "block" ||
          document.getElementById("dept-error").style.display !== "block"
        ) {
          document
            .getElementById(window.localStorage.getItem("LastIdClicked"))
            .click();
        }
      } else {
        if (
          document.getElementById("name-validation").style.display !==
            "block" &&
          document.getElementById("name").value.length > 0
        ) {
          document
            .getElementById(window.localStorage.getItem("LastIdClicked"))
            .click();
        }
      }
    }, 1500);
  };
  const closeBasicSettingsAlert = () => {
    setBasicSettingsCreated(true);
  };
  // called when the user clicks save changes on the BasicSettingsCreated validation
  const save = () => {
    document.getElementById("save-btn").click();
    setBasicSettingsCreated(true);
    setTimeout(() => {
      if (document.getElementById("name-label-holder").classList.length < 2) {
        document
          .getElementById(window.localStorage.getItem("LastIdClicked"))
          .click();
      }
    }, 1500);
  };
  return (
    <BrowserRouter basename="/home/acls/addACL">
      {!BasicSettingsCreated ? (
        <UnsavedChangesAlert
          close={() => closeBasicSettingsAlert()}
          save={() => save()}
          discard={() => null}
          AlertMessage={translateText("unsaved_changes_tab_switch_warning")}
          CancelText={translateText("cancel")}
          SaveText={translateText("save_changes")}
          LangData={props.LangData}
        />
      ) : null}
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => close()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
          LangData={props.LangData}
        />
      ) : null}
      <DesktopOnlyOverlay LangData={props.LangData} />
      <div className="main-content security-settings security-profiles">
        <ContentHeader PageName={translateText("access_control_lists")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("security_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("acls")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("add_acl")}</p>
          </div>
        </div>
        <div className="actions navigator navigator-sm">
          <span id="animated-indicator"></span>
          <NavLink
            onClick={(e) => validateNavigation(e, "basic-settings")}
            activeClassName="active-nav-node"
            exact
            id="basic-settings"
            to="/"
          >
            <p>{translateText("basic_settings")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "mapping")}
            activeClassName="active-nav-node"
            to="/mapping"
            id="mapping"
          >
            <p>{translateText("mapping")}</p>
          </NavLink>
          {/* <NavLink
            onClick={(e) => validateNavigation(e, "advanced")}
            activeClassName="active-nav-node"
            id="advanced"
            to="/advanced"
          >
            <p>Advanced</p>
          </NavLink> */}
        </div>
        <Switch>
          <Route path="/mapping" exact>
            <Mapping LangData={props.LangData} />
          </Route>
          <Route path="/advanced" exact>
            <Advanced />
          </Route>
          <Route path="/" exact>
            <BasicSettings LangData={props.LangData} />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default AddACL;
